export const getters = {
  LIST: state => state.list
}
